import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "linkedin-cta" }
const _hoisted_2 = { class: "linkedin-cta__content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ImportButton',
  props: {
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        duration: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        isMainTag: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!
  const _component_VJoyTag = _resolveComponent("VJoyTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VJoyIcon, {
      name: __props.icon,
      size: "small",
      class: "linkedin-cta__icon"
    }, null, 8, ["name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
      _createElementVNode("p", null, _toDisplayString(__props.description), 1),
      (__props.isMainTag)
        ? (_openBlock(), _createBlock(_component_VJoyTag, {
            key: 0,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.duration), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_VJoyTag, {
            key: 1,
            size: "small",
            variant: "secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.duration), 1)
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})